import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from "./views/Dashboard";
import Default from "@/components/layouts/Default";
import Blank from "@/components/layouts/Blank.vue";
import Login from "@/views/auth/Login.vue";
import Organization from "@/views/organization/Organization.vue";
import notify from "@/utils/notify";
import Employees from "@/views/employee/Employees.vue";
import EmployeeDetails from "@/views/employee/EmployeeDetails.vue";
import FileRequests from "@/views/employee/FileRequests.vue";
import Departments from "@/views/department/Departments.vue";
import Designations from "@/views/designation/Designations.vue";
import WorkStations from "@/views/station/WorkStations.vue";
import EmployeePayrolls from "@/views/payroll/EmployeePayrolls.vue";
import PayrollDetails from "@/views/payroll/PayrollDetails.vue";
import Payslip from "@/views/payroll/Payslip.vue";
import Users from "@/views/user/Users.vue";
import AddEmployee from "@/views/employee/AddEmployee.vue";
import ForgotPassword from "@/views/auth/ForgotPassword.vue";
import UpdatePassword from "@/views/auth/UpdatePassword.vue";
import UserProfile from "@/views/user/UserProfile.vue";
import ChangePassword from "@/views/user/ChangePassword.vue";
import UserEdit from "@/views/user/UserEdit.vue";
import AllOrganizations from "@/views/organization/AllOrganizations.vue";
import CommissionRates from "@/views/commission/CommissionRates.vue";
import EditEmployee from "@/views/employee/EditEmployee.vue";
import VerifyOtp from "@/views/auth/VerifyOtp.vue";
import Settings from "@/views/settings/Settings.vue";
import {decrypt} from "@/utils/crypto";
import Upgrade from "@/views/account/Upgrade.vue";
import PaymentSuccess from "@/views/account/PaymentSuccess.vue";
import Billing from "@/views/account/Billing.vue";
import Logs from "@/views/account/Logs.vue";
import AddOrganization from "@/views/organization/AddOrganization.vue";
import VerifyPayslip from "@/views/account/VerifyPayslip.vue";
import Templates from "@/views/account/Templates.vue";
import TemplatePreview from "@/views/account/TemplatePreview.vue";
import Integration from "@/views/account/Integration.vue";
import PayrollPayouts from "@/views/payroll/PayrollPayouts.vue";
import Casuals from "@/views/casual/Casuals.vue";
import CasualDetails from "@/views/casual/CasualDetails.vue";
import AddCasual from "@/views/casual/AddCasual.vue";
import EditCasual from "@/views/casual/EditCasual.vue";
import CasualPayrolls from "@/views/payroll/CasualPayrolls.vue";
import CasualPayrollDetails from "@/views/payroll/CasualPayrollDetails.vue";
import CasualPayrollPayouts from "@/views/payroll/CasualPayrollPayouts.vue";
import SSOAuth from "@/views/auth/SSOAuth.vue";
import AnnualReport from "@/views/analytics/AnnualReport.vue";
import LeaveTypes from "@/views/leave/LeaveTypes.vue";
import LeaveRequests from "@/views/leave/LeaveRequests.vue";
import LeaveBalances from "@/views/leave/LeaveBalances.vue";
import LeaveApprovers from "@/views/leave/LeaveApprovers.vue";
import MyLeaves from "@/views/employee-pages/MyLeaves.vue";
import MonthlyReport from "@/views/analytics/MonthlyReport.vue";
import MyPayslips from "@/views/employee-pages/MyPayslips.vue";
import MyLoans from "@/views/employee-pages/MyLoans.vue";
import LoanDetails from "@/views/employee-pages/LoanDetails.vue";
import GuarantorRequests from "@/views/employee-pages/GuarantorRequests.vue";
import LeaveApprovals from "@/views/employee-pages/LeaveApprovals.vue";

// Performance Management imports
import ReviewDetail from "@/views/performance/ReviewDetail.vue";
import Analytics from "@/views/performance/Analytics.vue";
import FeedbackForm from "@/views/performance/FeedbackForm.vue";
import ReviewTemplates from "@/views/performance/ReviewTemplates.vue";
import ReviewTemplateDetails from "@/views/performance/ReviewTemplateDetails.vue";
import ReviewCycles from "@/views/performance/ReviewCycles.vue";
import ReviewCycleDetails from "@/views/performance/ReviewCycleDetails.vue";
import MyPerformance from "@/views/employee-pages/MyPerformance.vue";
import MyReviews from "@/views/employee-pages/MyReviews.vue";
import MyFeedback from "@/views/employee-pages/MyFeedback.vue";

const router = createRouter({
    history: createWebHistory(),
    routes:[
        { path: '/', redirect: '/dashboard' },
        {
            path: '/',
            component: Default,
            children: [
                {
                    path:'/dashboard',
                    component:Dashboard,
                },
                {
                    path:'/organization',
                    component:Organization,
                    meta:{ permission: 'view organization' }
                },
                {
                    path:'/employees',
                    component:Employees,
                    meta:{ permission: 'view employees' }
                },
                {
                    path:'/employee/:id',
                    component:EmployeeDetails,
                },
                {
                    path:'/add-employee',
                    component:AddEmployee,
                    meta:{ permission: 'create employees' }
                },
                {
                    path:'/edit-employee/:id',
                    component:EditEmployee,
                    meta:{ permission: 'edit employees' }
                },
                {
                    path:'/file-requests',
                    component:FileRequests,
                    meta:{ permission: 'view employees' }
                },
                {
                    path:'/casuals',
                    component:Casuals,
                    meta:{ permission: 'view casuals' }
                },
                {
                    path:'/casual/:id',
                    component:CasualDetails,
                    meta:{ permission: 'view casuals' }
                },
                {
                    path:'/add-casual',
                    component:AddCasual,
                    meta:{ permission: 'create casuals' }
                },
                {
                    path:'/edit-casual/:id',
                    component:EditCasual,
                    meta:{ permission: 'edit casuals' }
                },
                {
                    path:'/departments',
                    component:Departments,
                    meta:{ permission: 'view departments' }

                },
                {
                    path:'/designations',
                    component:Designations,
                    meta:{ permission: 'view designations' }
                },
                {
                    path:'/work-stations',
                    component:WorkStations,
                    meta:{ permission: 'view work-stations' }
                },
                {
                    path:'/commission-rates',
                    component:CommissionRates,
                    meta:{ permission: 'view commission-rates' }
                },
                {
                    path:'/payrolls/employees',
                    component:EmployeePayrolls,
                    meta:{ permission: 'view payrolls' }
                },
                {
                    path:'/payrolls/casuals',
                    component:CasualPayrolls,
                    meta:{ permission: 'view payrolls' }
                },
                {
                    path:'/payroll/:id',
                    component:PayrollDetails,
                    meta:{ permission: 'view payrolls' }
                },
                {
                    path:'/payroll/casual/:id',
                    component:CasualPayrollDetails,
                    meta:{ permission: 'view payrolls' }
                },
                {
                    path:'/payslip/:id',
                    component:Payslip,
                },
                {
                    path:'/upgrade',
                    component:Upgrade,
                },
                {
                    path:'/templates',
                    component:Templates,
                },
                {
                    path:'/billing',
                    component:Billing,
                },
                {
                    path:'/integration',
                    component:Integration,
                },
                {
                    path:'/logs',
                    component:Logs,
                },
                {
                    path:'/users',
                    component:Users,
                    meta:{ permission: 'view users' }
                },
                {
                    path:'/profile',
                    component:UserProfile,
                },
                {
                    path:'/change-password',
                    component:ChangePassword,
                },
                {
                    path:'/user/:id',
                    component:UserEdit,
                    meta:{ permission: 'edit users' }
                },
                {
                    path:'/organizations',
                    component:AllOrganizations,
                },
                {
                    path:'/settings',
                    component:Settings,
                },
                {
                    path:'/paymentSuccess',
                    component:PaymentSuccess,
                },
                {
                    path:'/payrollPayouts/:id',
                    component:PayrollPayouts,
                    meta:{ permission: 'view payrolls' }
                },
                {
                    path:'/casualPayrollPayouts/:id',
                    component:CasualPayrollPayouts,
                    meta:{ permission: 'view payrolls' }
                },
                {
                    path:'/annual-report',
                    component:AnnualReport,
                    meta:{ permission: 'view annual-analytics' }
                },
                {
                    path:'/monthly-report',
                    component:MonthlyReport,
                    meta:{ permission: 'view monthly-analytics' }
                },
                {
                    path:'/leave-types',
                    component:LeaveTypes,
                    meta:{ permission: 'view leaves' }
                },
                {
                    path:'/leave-requests',
                    component:LeaveRequests,
                    meta:{ permission: 'view leaves' }
                },
                {
                    path:'/leave-balances',
                    component:LeaveBalances,
                    meta:{ permission: 'view leaves' }
                },
                {
                    path:'/leave-approvers',
                    component:LeaveApprovers,
                    meta:{ permission: 'view leaves' }
                },
                {
                    path:'/loans',
                    component:MyLoans,
                    meta:{ permission: 'view loans' }
                },
                {
                    path:'/review-templates',
                    component: ReviewTemplates,
                    meta:{ permission: 'view review templates' }
                },
                {
                    path:'/review-template/:id',
                    component: ReviewTemplateDetails,
                    meta:{ permission: 'view review templates' }
                },
                {
                    path:'/review-cycles',
                    component: ReviewCycles,
                    meta:{ permission: 'view review cycles' }
                },
                {
                    path:'/review-cycle/:id',
                    component: ReviewCycleDetails,
                    meta:{ permission: 'view review cycles' }
                },
                {
                    path:'/performance',
                    component:Analytics,
                    meta:{ permission: 'view performance analytics' }
                },
                {
                    path:'/performance/review/:id',
                    component:ReviewDetail,
                },
                {
                    path:'/performance/feedback/:id',
                    component:FeedbackForm
                },
                //////////////
                //
                // Employee only routes
                //
                /////////////
                {
                    path:'/my-payslips',
                    component: MyPayslips,
                },
                {
                    path:'/my-leaves',
                    component: MyLeaves,
                },
                {
                    path:'/leave-approvals',
                    component: LeaveApprovals,
                },
                {
                    path:'/my-loans',
                    component: MyLoans,
                },
                {
                    path:'/loan/:id',
                    component: LoanDetails,
                },
                {
                    path:'/guarantor-requests',
                    component:GuarantorRequests,
                },
                {
                    path:'/my-performance',
                    component:MyPerformance,
                },
                {
                    path:'/my-reviews',
                    component:MyReviews,
                },
                {
                    path:'/my-feedback',
                    component:MyFeedback,
                },
            ]
        },
        {
            path: '/',
            component: Blank,
            children: [
                {
                    path:'/login',
                    component:Login,
                },
                {
                    path:'/employee-login',
                    component:Login,
                },
                {
                    path:'/auth',
                    component:SSOAuth
                },
                {
                    path:'/signup',
                    component:Login,
                },
                {
                    path:'/verify-otp',
                    component:VerifyOtp
                },
                {
                    path:'/create-organization',
                    component:AddOrganization
                },
                {
                    path:'/forgot-password',
                    component:ForgotPassword,
                },
                {
                    path:'/update-password/:email',
                    component:UpdatePassword,
                },
                {
                    path:'/verifyPayslip/:id',
                    component:VerifyPayslip,
                },
                {
                    path:'/preview/:id',
                    component:TemplatePreview,
                },
            ],
        },
    ],
});

// User access control
let unauthenticated = ["login", "employee-login", "employee-logout", "logout", "auth", "signup", "verify-otp", "forgot-password", "update-password", "verifyPayslip"]
let superAdmin = ["organizations", "settings"]
let expiredSubscription = ["templates"]

let service = 'payroll'
let accounts = process.env.VUE_APP_ACCOUNTS_URL + 'login'
let nextUrl = process.env.VUE_APP_BASE_URL + 'auth'

router.beforeEach(async (to, from, next) => {
    let routeTo = to.path.split('/', 2)[1]
    const token = decrypt(sessionStorage.getItem('access_token'))
    if (!unauthenticated.includes(routeTo)) {
        if (token) {
            let profile = JSON.parse(decrypt(sessionStorage.getItem('profile')))
            let subscription = decrypt(sessionStorage.getItem('subscriptionStatus'))
            let isSuperAdmin = profile.role === 'super-admin'
            let permissions = profile.permissionNames

            if (profile.organization_id === null && routeTo !== 'create-organization') {
                notify.alert.info('Please create your organization first.')
                next('/create-organization')
            }

            if (to.meta.permission !== undefined && !permissions.includes(to.meta.permission)) {
                notify.alert.warning('You do not have permission to access this page.')
                next('/dashboard')
            }

            if (subscription === '' && expiredSubscription.includes(routeTo) || subscription === 'expired' && expiredSubscription.includes(routeTo)) {
                notify.alert.warning('You have an expired subscription. Please renew your subscription.')
                next('/dashboard')
            } else if (superAdmin.includes(routeTo) && !isSuperAdmin) {
                notify.alert.warning('You do not have permission to access this page.')
                next('/dashboard')
            }
            next()
        } else {
            window.open(accounts + '?service=' + service +'&next=' + nextUrl, '_self')
        }
    } else {

        if (routeTo === 'logout') {
            window.open(accounts + '?service=' + service +'&next=' + 'logout', '_self')
        }

        if (routeTo === 'login') {
            window.open(accounts + '?service=' + service +'&next=' + nextUrl, '_self')
        }

        if (routeTo === 'employee-login') {
            next()
        }

        if (token) {
            notify.alert.info('You have an active session. Please logout first.')
            next()
        }
        next()
    }
})

export default router;
